import { useState } from "react";
import { toast } from "sonner";
import { useTranslation } from "../contexts/TranslationContext";
import { useForm } from "react-hook-form";
import { emailValidation } from "../utils/validation.js";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
    const res = await fetch(`${import.meta.env.VITE_API_URL}/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: data.email }),
    });

      const responseData = await res.json();

      if (res.ok) {
        toast.success(responseData.message);
      } else {
        toast.error(responseData.error || t('forgotPassword.sendError'));
      }
    } catch (error) {
      toast.error(t('toasts.connectionError'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#111] border border-white/10 rounded-xl shadow-lg p-8">
        <h1 className="text-2xl font-bold text-center text-white mb-6">
          {t('forgotPassword.title')}
        </h1>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4" noValidate>
          <div>
            <input
              type="email"
              placeholder={t('forgotPassword.placeholder')}
              {...register("email", emailValidation(t))}
              className={`w-full p-3 border rounded-md bg-[#0a0a0a] text-white placeholder-gray-500 focus:outline-none focus:border-brand-500 ${
                errors.email ? 'border-red-500' : 'border-white/10'
              }`}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-brand-500 hover:bg-brand-400 text-black p-3 rounded-md transition font-semibold disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {isLoading && <Loader2 className="animate-spin" size={20} />}
            {t('forgotPassword.button')}
          </button>
        </form>
      </div>
    </div>
  );
}
